import React, { useEffect, useState } from "react";
import MotorcycleCard from "./motorcycle-item";
import { Helmet } from "react-helmet-async";
import "./shop.scss";

export default function MotorcycleList({ host }) {
  const [motorcycles, setMotorcycles] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    setLoading(true);

    fetch(
      `${host}/api/shop/motorcycles/?fields=id,title,price,main_image,mileage,production_year,engine_capacity,license_category`
    )
      .then((res) => res.json())
      .then((data) => {
        setMotorcycles(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading motorcycles:", err);
        setLoading(false);
      });
  }, [host]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = motorcycles.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(motorcycles.length / itemsPerPage);

  return (
    <section className="moto-list container">
      <>
          <Helmet>
              <title>Pro Moto - Sprzedaż i skup motocykli używanych</title>
              <meta
              name="description"
              content="PRO MOTO Sprzedaż i skup motocykli używanych"
              />
              <link rel="canonical" href="https://promotoserwis.pl/motocykle" />
          </Helmet>
      </>
      <h2>Aktualne oferty</h2>

      {loading && <div className="spinner"></div>}

      {!loading && (
        <div className="moto-list__grid">
          {currentItems.map((moto) => (
            <MotorcycleCard key={moto.id} moto={moto} host={host}/>
          ))}
        </div>
      )}

      {!loading && totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
          >
            ‹
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? "active" : ""}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            ›
          </button>
        </div>
      )}
    </section>
  );
}
